import React from "react"
import { Icon } from "helpers/getIcon"

import {
  ChecklistContainer,
  ItemContainer,
  ChecklistInputContainer,
} from "./style"

const allData = [
  {
    label: "Create a list of possible places to live in Canberra.",
    tip:
      "<span>Tip:</span> Talk to friends and relatives already living here and do some online research",
  },
  { label: "Develop a budget for when you move", tip: "" },
  {
    label: "Find out more about <a href='/'>job opportunities</a> in Canberra",
    tip: "",
  },
]
const Checklist = data => {
  console.log("data:", data)
  return (
    <ChecklistContainer>
      {data.data.map((item, index) => {
        const seq = (Math.floor(Math.random() * 10000) + 10000)
          .toString()
          .substring(1)

        return (
          <ItemContainer key={index}>
            <ChecklistInputContainer tip={item.tip}>
              <input type="checkbox" id={seq}></input>
              <label
                htmlFor={seq}
                dangerouslySetInnerHTML={{ __html: item.description }}
              ></label>
              <span className="checkmark" aria-hidden="true">
                <Icon name="checked-mark" />
              </span>
            </ChecklistInputContainer>

            {item.tip && (
              <div className="tip">
                <span>Tip:</span>{" "}
                <p dangerouslySetInnerHTML={{ __html: item.tip }} />
              </div>
            )}
          </ItemContainer>
        )
      })}
    </ChecklistContainer>
  )
}

export default Checklist
